<template>
  <div style="display: flex; align-items: center;">

    <component
      v-if="actionsTemplate"
      :is="actionsTemplate"
    ></component>


    <div v-else class="header-actions">

      <notifications
        style="margin-left: 15px"
        :user-id="user.id"
      ></notifications>


      <div>
        <div>{{ user.last_name }} {{ user.first_name }}</div>
      </div>


      <el-tooltip content="Выход" placement="top-start">
        <el-button
          size="mini"
          type="text"
          icon="fas fa-sign-out-alt"
          @click="logout"
        >
        </el-button>
      </el-tooltip>


      <deputy-modal
        v-if="$canAndRulesPass(user, $permissions.USER.DEPUTIES_LOGIN)"
        style="margin-top: 1px;"
      ></deputy-modal>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Notifications from "@/components/Notifications.vue";
import router from "@/router";
import DeputyModal from "@/auth/DeputyModal.vue";

export default {
  name: "actions-component",
  components: {DeputyModal, Notifications},

  props: {},

  watch: {},
  computed: {
    ...mapGetters(['user']),
    actionsTemplate() {
      return this.$companyConfiguration.settings.getActionsTemplate();
    },
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {
    logout() {
      this.$store.dispatch('logoutUser');
      router.push({ name: 'Login'});
    },
  }
}
</script>


<style lang="scss">
.header-actions{
  display: flex;
  align-items: center;
  gap: 20px;
}
</style>